<template>
  <!-- <div> -->
  <v-row justify="center" class="ma-2">
    <v-dialog v-model="dialog" width="95%" dark>
      <template v-slot:activator="{ on }">
        <v-btn small text color="green darken-3" rounded v-on="on"
          >CREATE DOCUMENT</v-btn
        >
      </template>
      <v-card
        style="
          border-radius: 26px;
          height: 90vh;
          background-color: black;
          border: 3px solid #18cae6;
        "
      >
        <v-card-title class="ma-auto">
          <span class="headline">CREATE A DOCUMENT</span>
          <v-spacer></v-spacer>
          <v-btn rounded color="red" @click="cancelDialog">CANCEL</v-btn>
        </v-card-title>
        <div v-if="responses.formDef">
          <div class="subtitle-2">
            Form Title:
            <span class="orange--text">{{ responses.formDef.formTitle }}</span>
          </div>
          <div class="subtitle-2">
            Respondent Name:
            <span class="orange--text">
              {{ responses.firstName }}
              {{ responses.lastName }}
            </span>
          </div>
          <div class="subtitle-2">
            Respondent Email:
            <span class="orange--text">{{ responses.username }}</span>
          </div>
        </div>
        <div v-if="responses.id">
          <div class="subtitle-2">
            Form Title:
            <span class="orange--text">{{ responses.name }}</span>
          </div>
          <div class="subtitle-2">
            Response ID:
            <span class="orange--text">{{ responses.id }}</span>
          </div>
          <div class="subtitle-2">
            Responent Name:
            <span class="orange--text">{{ responses.partyName }}</span>
          </div>
        </div>

        <v-expand-transition v-if="showSignaturePad">
          <v-card color="black">
            <v-form>
              <div class="ma-auto mt-3">
                <v-autocomplete
                  label="SELECT A DOCUMENT TO CREATE"
                  :items="docList"
                  v-model="selectedDoc"
                  dense
                  style="max-width: 60%"
                  class="ma-auto"
                  outlined
                ></v-autocomplete>
                <v-text-field
                  label="SET NUMBER (REQUIRED)"
                  v-model="setNumber"
                  dense
                  style="max-width: 60%"
                  class="ma-auto"
                  outlined
                ></v-text-field>
                <v-autocomplete
                  label="SELECT AN ATTORNEY TO SIGN"
                  :items="matter.attorneys"
                  item-text="name"
                  v-model="selectedAttorney"
                  dense
                  style="max-width: 60%"
                  class="ma-auto"
                  outlined
                ></v-autocomplete>
                <v-autocomplete
                  label="SELECT A PROPOUNDING PARTY (OPTIONAL)"
                  :items="matter.defendants"
                  item-text="fullName"
                  v-model="propoundingParty"
                  dense
                  style="max-width: 60%"
                  class="ma-auto"
                  outlined
                ></v-autocomplete>
              </div>

              <v-card class="ma-auto" width="60%" shaped color="black">
                <!-- <v-layout class="ma-auto" row> -->

                <v-text-field
                  width="70%"
                  class="ma-auto"
                  v-model="tempVerificationFor"
                  label="Verification List:"
                  outlined
                  dense
                ></v-text-field>
                <v-card-actions>
                  <v-btn
                    small
                    rounded
                    color="green"
                    @click="addVerificationItem()"
                    >+</v-btn
                  >
                </v-card-actions>
                <!-- </v-layout> -->
                <div v-if="verificationList" class="ma-auto">
                  <v-layout
                    class="ma-auto"
                    v-for="(verificationItem, index) in verificationList"
                    :key="index"
                    row
                    style="max-width: 60%"
                  >
                    <div class="mr-2">{{ verificationItem }}</div>
                    <v-btn
                      class="ml-2"
                      small
                      rounded
                      color="red"
                      @click="removeVerificationItem(index)"
                      >-</v-btn
                    >
                  </v-layout>
                </div>
              </v-card>
            </v-form>
            <v-card-text align="center" class="ma-auto"
              >ATTORNEY SIGNATURE BOX</v-card-text
            >
            <v-expand-transition v-if="showSignaturePad">
              <VueSignaturePad
                width="500px"
                height="200px"
                ref="signaturePad"
                style="border: 1px solid blue; background-color: white"
                class="ma-auto"
              />
            </v-expand-transition>

            <v-card-actions class="ma-auto">
              <v-spacer></v-spacer>
              <v-btn @click="save">Save</v-btn>
              <v-btn @click="undo">Undo</v-btn>
              <!-- <v-btn @click="logResps">LOG RESPS</v-btn> -->
              <v-btn @click="testPDF" :disabled="!selectedAttorney"
                >APPLY</v-btn
              >

              <!-- <v-btn @click="testPDF" v-if="edit" :disabled="!selectedAttorney">EDIT</v-btn> -->
              <v-spacer></v-spacer>
              <v-btn @click="cancelDialog">CANCEL</v-btn>
            </v-card-actions>
          </v-card>
        </v-expand-transition>
        <v-btn v-if="!showSignaturePad" @click="showSignaturePad = true"
          >EDIT</v-btn
        >
        <v-btn v-if="!showSignaturePad" @click="downloadDoc">DOWNLOAD</v-btn>

        <div style="width: 100%; height: 100%">
          <v-progress-circular
            class="text-center ma-auto"
            indeterminate
            size="64"
            v-if="overlay"
          ></v-progress-circular>

          <iframe
            :src="iframeSrc"
            frameborder="0"
            style="width: 100%; height: 100%"
            class="ma-auto"
          ></iframe>
        </div>
        <!-- </v-layout> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 *
 *
 * this component takes a plaintiff object and a matter object and allows the
 * user to make a document that is specific to the plaintiff selected
 *
 *
 */

import * as firebase from "firebase";
import VueSignaturePad from "vue-signature-pad";

import * as moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// import { parse } from "path";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  //these props are passed down from the higher component
  props: ["matter", "user", "responses", "plaintiff"],
  components: {
    VueSignaturePad
  },
  data() {
    return {
      doc: null,
      overlay: false,
      attorneySignature: null,
      selectedAttorney: null,
      docList: [
        "PLAINTIFF FACT SHEET - FIRE",
        "WOOLSEY FIRE CASES, JCCP 5000 - PERSONAL CLAIMS",
        "CREEK FIRE CASES, JCCP 4965 - PERSONAL CLAIMS",
        "CREEK FIRE CASES, JCCP 4965 - PROPERTY CLAIMS",
        "PLAINTIFF'S RESPONSE TO FORM INTERROGATORIES"
      ],
      selectedDoc: null,
      resultDoc: null,
      dialog: false,
      iframeSrc: null,
      showSignaturePad: true,
      setNumber: null,
      propoundingParty: "",
      tempVerificationFor: null,
      verificationList: [],
      invoice: null
    };
  },
  computed: {
    clientSignature() {
      /*if this is an older cleint object 
      the database for this form definition will be 
      slightly different so I have to have this check 
      in here until the database is sanitized for the 
      few earlier clients that were input
      */
      if (this.responses.formDef) {
        return this.responses.formDef.responses["model: 'signature'"];
      } else {
        //this is the newer clients form response object
        return this.responses.responses["model: 'signature'"];
      }
    },

    firm() {
      //gets the current firm from the database
      return this.$store.getters.firm;
    },
    // user() {
    //   return this.$store.getters.user;
    // },
    //this is a string that is used in certain parts of the documents generated on taplaw
    plaintiffString() {
      let tempPlaintiffString = ``;
      this.matter.plaintiffs.forEach(plaintiff => {
        tempPlaintiffString += ` ${plaintiff.fullName.toUpperCase()};`;
      });
      return tempPlaintiffString;
    },
    defendantString() {
      let tempDefendantString = ``;
      this.matter.defendants.forEach(defendant => {
        tempDefendantString += ` ${defendant.fullName.toUpperCase()};`;
      });
      return (tempDefendantString += ` DOES 1 THROUGH 50, INCLUSIVE,`);
    }
  },
  methods: {
    /*when a client signs a verification to authenticate their responses 
    the document that is genereated must contain a list of document names 
    that are being verified by the signature. This allows the law firm user to add the 
    names of any document that should be included in the verification these methods deal with that
    */
    addVerificationItem() {
      this.verificationList.push(`${this.tempVerificationFor.toUpperCase()}`);
      this.tempVerificationFor = null;
      console.log(this.verificationList);
    },
    removeVerificationItem(index) {
      this.verificationList.splice(index, 1);
    },
    undo() {
      /**ths resets the signature box for Attorney signature when creating a document within this component */
      console.log(this.$refs.signaturePad);
      this.showSignaturePad = true;
      const { isEmpty } = this.$refs.signaturePad.saveSignature();

      if (!isEmpty) {
        this.$refs.signaturePad.clearSignature();
      }

      // this.showSignaturePad = true;
    },
    save() {
      /**this saves the signature in the signature pad to be applied to the document */
      //todo - make this better in the ui
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // this.signature = this.$refs.signaturePad.toDataURL(data);
      this.attorneySignature = data;

      console.log(isEmpty);
      // console.log(data);

      //this checks if the signature is a string which means that the user applied a signature in the
      //signature pad, if not, a cursive type font is applied to the document with the attorney's name
      // if (typeof this.attorneySignature === `string`) {
      // console.log("dis be a string");
      // }
      // console.log(typeof this.attorneySignature);
    },
    cancelDialog() {
      this.iframeSrc = null;
      this.dialog = false;
    },
    logResps() {
      console.log(this.responses);
    },
    downloadDoc() {
      let title = `${this.plaintiff.fullName}_${this.selectedDoc}`;
      this.doc.download(title);
    },
    tempCreatePDF() {
      console.log("this.plaintiff", this.plaintiff);
      console.log("this.responses", this.responses);
    },
    /**this function creates the PDF and displays it in the iframe */
    testPDF() {
      this.showSignaturePad = false;
      let lossDate = "the date of the fire";
      if (
        this.selectedDoc === "WOOLSEY FIRE CASES, JCCP 5000 - PERSONAL CLAIMS"
      ) {
        lossDate = "November 8, 2018";
      }
      if (
        this.selectedDoc === "CREEK FIRE CASES, JCCP 4965 - PERSONAL CLAIMS"
      ) {
        lossDate = "December 5, 2017";
      }
      if (
        this.selectedDoc === "CREEK FIRE CASES, JCCP 4965 - PROPERTY CLAIMS"
      ) {
        lossDate = "December 5, 2017";
      }
      //pdf make requires the fonts t0 be explicitly set these .ttf files must be present
      //in node_modules/pdfMake/examples/fonts
      //roboto comes default
      pdfMake.fonts = {
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf"
        },

        Amiri: {
          normal: "Amiri-Regular.ttf",
          bold: "Amiri-Bold.ttf",
          italics: "Amiri-Italic.ttf",
          bolditalics: "Amiri-BoldItalic.ttf"
        },
        TimesRoman: {
          normal: "Times New Roman.ttf",
          bold: "Times New Roman Bold.ttf",
          italics: "Times New Roman Italic.ttf",
          bolditalics: "Times New Roman Bold Italic.ttf"
        },

        Wingdings: {
          normal: "Wingdings.ttf"
        },

        Zapfino: {
          normal: "Zapfino.ttf"
        }
      };

      //AUTHO STACK
      //this ends up in the final document definition
      let authorStack = [];
      this.matter.attorneys.forEach(attorney => {
        authorStack.push({
          text: `${attorney.fullName.toUpperCase()}`,
          //explicitly setting lineHeight because the res of the documents is 1.5
          lineHeight: 1.0
        });
      });
      // console.log("this.plaintiff", this.plaintiff);
      // let plaintiffFullName = this.responses.fullName.toUpperCase();

      //ATTORNEY SIGNATURE
      //ends up in the document definition
      let signatureBody = {};
      //if the user applied a signature to the signature pad, there will be a string in this.attorneySingature
      //if not, it will be this.selectedAttorney will be printed in Zapfino
      if (this.attorneySignature) {
        signatureBody = {
          image: `${this.attorneySignature}`,
          width: 150,
          height: 40,
          alignment: "center",
          border: [false, false, false, true]
        };
      } else {
        signatureBody = {
          // text: `\n\nBy:       /s/${this.selectedAttorney.toUpperCase()}/s/`,
          // text: `\n\nBy:       ${this.selectedAttorney}`,
          text: [
            { text: `\n\nBy:` },
            {
              text: `    ${this.selectedAttorney}`,
              preserveLeadingSpaces: true,
              font: "Zapfino"
            }
          ],
          alignment: "left",
          border: [false, false, false, true]
          // font: "Zapfino"
        };
      }

      //TITLE(CASE) STACK
      //also ends up in the document definition that pdfMake turns into a pdf
      let titleStack;
      //if the user indicated that this matter has a special title, it is placed here.
      if (this.matter.specialTitle) {
        titleStack = [
          //SPECIAL TITLE
          {
            text: `Coordination Proceeding`,
            margin: [0, 4, 0, 0]
          },
          {
            text: `Special Title (Rule 3.550)`,
            margin: [0, 4, 0, 0]
          },
          {
            text: ` `,
            margin: [0, 4, 0, 0]
          },
          {
            text: `${this.matter.specialTitle.toUpperCase()}`,
            margin: [0, 4, 0, 0],
            bold: true
          },
          {
            text: ` `,
            margin: [0, 4, 0, 0]
          },
          //PLAINTIFFS
          {
            text: `${this.plaintiffString}`,
            margin: [0, 4, 0, 0]
          },
          {
            text: `Plaintiff(s),`,
            margin: [0, 4, 4, 0],
            alignment: "right"
          },

          { text: "v.", alignment: "center", lineHeight: 1.5 },

          //DEFENDANTS
          { text: `${this.defendantString}` },
          {
            text: `Defendant(s).`,
            margin: [0, 4, 4, 0],
            alignment: "right",
            lineHeight: 1.0
          }
        ];
      } else {
        titleStack = [
          //PLAINTIFFS
          {
            text: `${this.plaintiffString}`,
            margin: [0, 4, 0, 0]
          },
          {
            text: `Plaintiff(s),`,
            margin: [0, 4, 4, 0],
            alignment: "right"
          },

          { text: "v.", alignment: "center", lineHeight: 1.5 },

          //DEFENDANTS
          { text: `${this.defendantString}` },
          {
            text: `Defendant(s).`,
            margin: [0, 4, 4, 2],
            alignment: "right",
            lineHeight: 1.0
          }
          // { text: ` ` }
        ];
      }

      //this is a cloud function that is fired
      //with the below data, including the name of the document, and the responses object
      //depending on the "selectedDoc" attribute, the cloud function takes the responses object and
      //spits out a few objects that become the body of the document
      // firebase
      //   .app()
      //   .functions()
      //   .useFunctionsEmulator("http://localhost:5001");
      const getDocDef = firebase.functions().httpsCallable("getDocDef");
      // if (this.responses.formResponses.preMadeFormResponses) {
      //test
      //this should be changed to be preMadeForm item's responses if any
      //this if statement is required because some of the early client inputs had a different structure
      //I had to make the next iteration backward compatible
      //but now we can delete the older clients altogether and change this fucntion after
      ////////////////////////////////
      ////////////////////////////////
      ////////////////////////////////
      //TESTING PROPERTY QUESTIONNAIRE
      ////////////////////////////////
      if (
        this.selectedDoc === "CREEK FIRE CASES, JCCP 4965 - PROPERTY CLAIMS"
      ) {
        // firebase
        //   .app()
        //   .functions()
        //   .useFunctionsEmulator("http://localhost:5001");
        const getFirePropertyClaimDoc = firebase
          .functions()
          .httpsCallable("getFirePropertyClaimDoc");
        this.overlay = true;
        //cud function we declared earlier being called with data
        let firm = {
          firmName: this.firm.firmName,
          firmAddressLine: this.firm.firmAddressLine,
          firmCityStateZip: this.firm.firmCityStateZip
        };
        console.log("matter : ", this.matter);
        let matter = {
          jdxJudge: this.matter.jdxJudge,
          jdxDepartment: this.matter.jdxDepartment,
          caseNumber: this.matter.caseNumber
        };
        getFirePropertyClaimDoc({
          plaintiff: this.plaintiff,
          matter: matter,
          user: this.user,
          selectedDoc: this.selectedDoc,
          attorneySignature: this.attorneySignature,
          selectedAttorney: this.selectedAttorney,
          responses: this.responses,
          setNumber: this.setNumber,
          propoundingParty: this.propoundingParty,
          //already made document features
          authorStack,
          // verificationStack,
          titleStack,
          signatureBody,
          plaintiffString: this.plaintiffString,
          defendantString: this.defendantString,
          //so that the firm information can be obtained by the function
          firm: firm,
          docDate: moment().format("LL"),
          verificationList: this.verificationList,
          lossDate
        })
          .then(result => {
            console.log("selected Doc", this.selectedDoc);
            this.resultDoc = result.data;
            console.log("doc def from cloud function", this.resultDoc);
            //place the result inside this document definition in here
            //pdfMake will turn this into a pdf
            let docDef = {
              info: {
                title: `${this.plaintiff.fullName}_${this.selectedDoc}`,
                author: `${this.user.fullName}`
                // subject: 'subject of document',
                // keywords: 'keywords for document',
              },
              // ...this is the background formatting that is present on every page
              background: () => {
                return [
                  {
                    style: "tableExample",
                    table: {
                      widths: [72, "*", 36],
                      body: [
                        [
                          {
                            text: "",
                            border: [false],
                            margin: [0, 72, 0, 0]
                          },
                          {
                            text: "",
                            border: [true, false, true, false]
                          },
                          {
                            text: "",
                            border: [false]
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: "1" },
                              { text: "2" },
                              { text: "3" },
                              { text: "4" },
                              { text: "5" },
                              { text: "6" },
                              { text: "7" },
                              { text: "8" },
                              { text: "9" },
                              { text: "10" },
                              { text: "11" },
                              { text: "12" },
                              { text: "13" },
                              { text: "14" },
                              { text: "15" },
                              { text: "16" },
                              { text: "17" },
                              { text: "18" },
                              { text: "19" },
                              { text: "20" },
                              { text: "21" },
                              { text: "22" },
                              { text: "23" },
                              { text: "24" },
                              { text: "25" },
                              { text: "26" },
                              { text: "27" },
                              { text: "28" }
                            ],
                            alignment: "right",
                            lineHeight: 1.8,
                            border: [false, false, true, false],
                            margin: []
                          }, //END BACKGROUND STACK OBJECT
                          [
                            {
                              text: ""
                            }
                          ],
                          {
                            text: [" "],
                            border: [true, false, false, false]
                          }
                        ]
                      ] //END BACKGROUND BODY ARRAY
                    },
                    layout: { defaultBorder: false } //END BACKGROUND TABLE OBJECT
                  } //END BACKGROUND OBJECT
                ]; //END BACKGROUND RETURN ARRAY
              }, //END BACKGROUND

              //BEGIN FOOTER
              // footer: function(currentPage, pageCount){
              footer: currentPage => {
                return [
                  {
                    table: {
                      widths: [72, "*", 36],
                      // heights: [50, 50, 50],
                      body: [
                        [
                          {
                            text: "",
                            border: [false, false, true, false]
                          },
                          {
                            stack: [
                              //TESTING TO SELECT PLAINTIFF
                              // {text: `${matter.plaintiffs[0].fullName.toUpperCase()}'S --document title --`, alignment: 'center', fontSize: 12},
                              // {text: `${finalDocument.questions[0].response}`, alignment: 'center', fontSize: 8},
                              // {
                              //   text: `${this.plaintiff.fullName}`,
                              //   alignment: "center",
                              //   fontSize: 8
                              // },
                              {
                                text: `${this.resultDoc.footerText}`,
                                alignment: "center",
                                fontSize: 8
                              },
                              {
                                text: `${currentPage.toString()}`,
                                alignment: "center",
                                fontSize: 9
                              }
                            ],
                            layout: { defaultBorder: false },
                            border: [false, true, false, false]
                          },
                          { text: "", border: [true, false, false, false] }
                        ]
                      ]
                    }
                  }
                ];
              },
              //end footer
              // userPassword: '123',
              // watermark: {
              //   text: "TAPLAW DRAFT",
              //   color: "red",
              //   opacity: 0.3,
              //   angle: 70,
              //   fontSize: 40,
              // },
              content: [
                // AUTHOR STACK
                {
                  stack: [
                    authorStack,

                    // { text: `${this.user.email}`, lineHeight: 0.6 },

                    {
                      text: `${this.firm.firmName.toUpperCase()}`,
                      lineHeight: 1.0
                    },
                    {
                      text: `${this.firm.firmAddressLine.toUpperCase()}`,
                      lineHeight: 1.0
                    },
                    {
                      text: `${this.firm.firmCityStateZip.toUpperCase()}`,
                      lineHeight: 1.0
                    },
                    {
                      text: `TELEPHONE: ${this.firm.firmPhone
                        .trim()
                        .toUpperCase()}`,
                      lineHeight: 1.0
                    },
                    {
                      text: `FACSIMILE: ${this.firm.firmPhone
                        .trim()
                        .toUpperCase()}`,
                      lineHeight: 1.0
                    },
                    // { text: `${this.user.email}`, lineHeight: 1.0 },
                    { text: " ", lineHeight: 1.0 },
                    {
                      text: `Attorneys for:  ${this.responses.partyName.toUpperCase() ||
                        "Plaintiffs"}`,
                      lineHeight: 1.0
                    }
                  ],
                  margin: [44, 2, 7, 0],
                  lineHeight: 0,
                  fontSize: 12
                },
                //JURISDICTION STACK
                {
                  stack: [
                    {
                      text: `SUPERIOR COURT OF THE STATE OF CALIFORNIA`,
                      margin: [0, 40, 0, 0]
                    },
                    // {
                    //   text: `FOR THE COUNTY OF ${this.matter.jdxCounty.toUpperCase() ||
                    //     "null"}`
                    // }
                    {
                      text: `FOR THE COUNTY OF ${this.matter.jdxCounty ||
                        "null"}`
                    }
                  ],
                  fontSize: 12,
                  alignment: "center",
                  lineHeight: 1,
                  bold: true
                },

                //BEGIN CAPTION STACK
                this.resultDoc.caption,

                //BEGIN BODY STACK
                {
                  stack: [
                    this.resultDoc.docBody,

                    {
                      stack: [this.resultDoc.verificationStack],
                      margin: [0, 0, 40, 0]
                    },
                    // verificationStack,
                    // PROOF OF SERVICE STACK
                    {
                      stack: [
                        {
                          text: `PROOF OF SERVICE`,
                          alignment: "center",
                          bold: true,
                          pageBreak: "before",
                          margin: [0, 0, 0, 0]
                        },
                        { text: " " },
                        {
                          text: `STATE OF CALIFORNIA             )`,
                          alignment: "left"
                        },
                        {
                          text: `                                                ) ss.`,
                          alignment: "left",
                          preserveLeadingSpaces: true
                        },
                        {
                          text: `COUNTY OF LOS ANGELES      )`,
                          alignment: "left"
                        },
                        {
                          text: ` `
                        },
                        {
                          text: ` I am employed in the County of Los Angeles, State of California.  I am over the age of 18 and not a party to the within action; my business address is TAPLAW HEAD QUERTERS, LOS ANGELES CALIFORNIA. On ____________________, I served the foregoing document described as ###TEST DOC##### has been served on the interested party(ies) in this action as follows:`,
                          alignment: "justify"
                        },
                        { text: ` ` },
                        {
                          stack: [
                            {
                              table: {
                                widths: [10, "*"],
                                body: [
                                  [
                                    {
                                      text: `${this.byMail || ""}`
                                    },
                                    {
                                      text: `(BY MAIL) TAPLAW has deposited such envelope in the mail at TAPLAW HEADQUARTERS. The envelope was mailed with postage thereon fully prepaid. I am readily familiar with TAPLAW's practice of collection and processing of correspondence for mailing. It is deposited with the U.S. Postal Service on the same day in the ordinary course of business. I am aware that on motion of the party served, service is presumed invalid if postal cancellation date or postage meter date is more than 1 day after date of deposit for mailing in affidavit. (TO ALL NOTED ON SERVICE LIST)`,
                                      // margin: [60, 0, 0, 0]
                                      border: [true, true, true, false]
                                    }
                                  ]
                                ]
                              }
                            },
                            {
                              table: {
                                widths: [10, "*"],
                                body: [
                                  [
                                    {
                                      text: `${this.byPersonalService || ""}`,
                                      border: [true, true, true, false]
                                    },
                                    {
                                      text: `(BY PERSONAL SERVICE) TAPLAW caused such envelope to be delivered by hand to the addressee(s).`,
                                      // margin: [60, 0, 0, 0]
                                      border: [true, true, true, false]
                                    }
                                  ]
                                ]
                              }
                            },
                            {
                              table: {
                                widths: [10, "*"],
                                body: [
                                  [
                                    {
                                      text: `${this.byOvernightDelivery || ""}`,
                                      border: [true, true, true, false]
                                    },
                                    {
                                      text: `(BY OVERNIGHT DELIVERY) TAPLAW caused such envelope to be delivered by overnight delivery in a box regularly maintained by an overnight delivery service with delivery fees paid or provided for in accordance with ordinary business practices. (TO ALL NOTED ON SERVICE LIST)`,
                                      // margin: [60, 0, 0, 0]
                                      border: [true, true, true, false]
                                    }
                                  ]
                                ]
                              }
                            },
                            {
                              table: {
                                widths: [10, "*"],
                                body: [
                                  [
                                    {
                                      text: `${this.byEmail || ""}`,
                                      border: [true, true, true, false]
                                    },
                                    {
                                      text: `(BY EMAIL) Based on court order or an agreement of the parties to accept service by e-mail or electronic transmission, TAPLAW caused such documents to be sent to the persons at the email addressses listed in the attahced mailing list. TAPLAW has not received any electronic message or other indication that the transmission was unsuccessfull.(TO ALL NOTED ON SERVICE LIST)`,
                                      // margin: [60, 0, 0, 0]
                                      border: [true, true, true, false]
                                    }
                                  ]
                                ]
                              }
                            },
                            {
                              table: {
                                widths: [10, "*"],
                                body: [
                                  [
                                    {
                                      text: `X`,
                                      border: [true, true, true, false]
                                    },
                                    {
                                      text: `(STATE) I declare under penalty of perjury under the laws of the State of California that the above is true and correct.`,
                                      // margin: [60, 0, 0, 0]
                                      border: [true, true, true, false]
                                    }
                                  ]
                                ]
                              }
                            },
                            {
                              table: {
                                widths: [10, "*"],
                                body: [
                                  [
                                    {
                                      text: `    `
                                    },
                                    {
                                      text: `(FEDERAL) I declare under penalty of perjury under the laws of the United States of America that the above is true and correct.`
                                      // margin: [60, 0, 0, 0]
                                    }
                                  ]
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      lineHeight: 1.0,
                      alignment: "justify",
                      margin: [0, 0, 40, 0]
                    }
                  ],
                  lineHeight: 1.8,
                  fontSize: 12,
                  margin: [44, 0, 0, 0]
                } //END BODY
              ],
              pageMargins: [42, 78, 55, 40], //END CONENT SACK

              //BEGIN BACKGROUND STYLES
              styles: {
                header: {
                  fontSize: 18,
                  bold: true,
                  margin: [0, 0, 0, 10]
                },
                subheader: {
                  fontSize: 16,
                  bold: true,
                  margin: [0, 10, 0, 5]
                },
                tableExample: {
                  margin: [0, 0, 0, 0]
                },
                tableHeader: {
                  bold: true,
                  fontSize: 13,
                  color: "black"
                }
              },
              defaultStyle: {
                // alignment: 'justify',
                font: "TimesRoman"
              },
              pageSize: "LETTER"
            }; //END (dd) DOCUMENT DENFENITION
            // let title = `${this.plaintiff.fullName}_${this.selectedDoc}`;
            this.doc = pdfMake.createPdf(docDef);
            // doc.download(title);
            this.doc.getDataUrl(url => {
              this.iframeSrc = url;
            });
            this.overlay = false;
          })
          .catch(err => {
            console.log(err);
            this.overlay = false;
          });
      }
      //////////////////////////////
      //////////////////////////////
      //////////////////////////////
      //////////////////////////////
      //////////////////////////////
      //END TESTING PROPERTY QUESTIONNAIRE
      //////////////////////////////
      //////////////////////////////
      else {
        if (this.responses.responses) {
          //this overlay is a loading spinner the entire function process takes a couple seconds
          this.overlay = true;
          //cud function we declared earlier being called with data
          let firm = {
            firmName: this.firm.firmName,
            firmAddressLine: this.firm.firmAddressLine,
            firmCityStateZip: this.firm.firmCityStateZip
          };
          console.log("matter : ", this.matter);
          let matter = {
            jdxJudge: this.matter.jdxJudge,
            jdxDepartment: this.matter.jdxDepartment,
            caseNumber: this.matter.caseNumber,
            specialTitle: this.matter.specialTitle
          };
          // firebase
          //   .app()
          //   .functions()
          //   .useFunctionsEmulator("http://localhost:5001");
          getDocDef({
            plaintiff: this.plaintiff,
            matter: matter,
            user: this.user,
            selectedDoc: this.selectedDoc,
            attorneySignature: this.attorneySignature,
            selectedAttorney: this.selectedAttorney,
            responses: this.responses,
            setNumber: this.setNumber,
            propoundingParty: this.propoundingParty,
            //already made document features
            authorStack,
            // verificationStack,
            titleStack,
            signatureBody,
            plaintiffString: this.plaintiffString,
            defendantString: this.defendantString,
            //so that the firm information can be obtained by the function
            firm: firm,
            docDate: moment().format("LL"),
            verificationList: this.verificationList,
            lossDate
          })
            .then(result => {
              console.log("selected Doc", this.selectedDoc);
              this.resultDoc = result.data;
              console.log("doc def from cloud function", this.resultDoc);
              //place the result inside this document definition in here
              //pdfMake will turn this into a pdf
              let docDef = {
                info: {
                  title: `${this.plaintiff.fullName}_${this.selectedDoc}`,
                  author: `${this.user.fullName}`
                  // subject: 'subject of document',
                  // keywords: 'keywords for document',
                },
                // ...this is the background formatting that is present on every page
                background: () => {
                  return [
                    {
                      style: "tableExample",
                      table: {
                        widths: [72, "*", 36],
                        body: [
                          [
                            {
                              text: "",
                              border: [false],
                              margin: [0, 72, 0, 0]
                            },
                            {
                              text: "",
                              border: [true, false, true, false]
                            },
                            {
                              text: "",
                              border: [false]
                            }
                          ],
                          [
                            {
                              stack: [
                                { text: "1" },
                                { text: "2" },
                                { text: "3" },
                                { text: "4" },
                                { text: "5" },
                                { text: "6" },
                                { text: "7" },
                                { text: "8" },
                                { text: "9" },
                                { text: "10" },
                                { text: "11" },
                                { text: "12" },
                                { text: "13" },
                                { text: "14" },
                                { text: "15" },
                                { text: "16" },
                                { text: "17" },
                                { text: "18" },
                                { text: "19" },
                                { text: "20" },
                                { text: "21" },
                                { text: "22" },
                                { text: "23" },
                                { text: "24" },
                                { text: "25" },
                                { text: "26" },
                                { text: "27" },
                                { text: "28" }
                              ],
                              alignment: "right",
                              lineHeight: 1.8,
                              border: [false, false, true, false],
                              margin: []
                            }, //END BACKGROUND STACK OBJECT
                            [
                              {
                                text: ""
                              }
                            ],
                            {
                              text: [" "],
                              border: [true, false, false, false]
                            }
                          ]
                        ] //END BACKGROUND BODY ARRAY
                      },
                      layout: { defaultBorder: false } //END BACKGROUND TABLE OBJECT
                    } //END BACKGROUND OBJECT
                  ]; //END BACKGROUND RETURN ARRAY
                }, //END BACKGROUND

                //BEGIN FOOTER
                // footer: function(currentPage, pageCount){
                footer: currentPage => {
                  return [
                    {
                      table: {
                        widths: [72, "*", 36],
                        // heights: [50, 50, 50],
                        body: [
                          [
                            {
                              text: "",
                              border: [false, false, true, false]
                            },
                            {
                              stack: [
                                //TESTING TO SELECT PLAINTIFF
                                // {text: `${matter.plaintiffs[0].fullName.toUpperCase()}'S --document title --`, alignment: 'center', fontSize: 12},
                                // {text: `${finalDocument.questions[0].response}`, alignment: 'center', fontSize: 8},
                                // {
                                //   text: `${this.plaintiff.fullName}`,
                                //   alignment: "center",
                                //   fontSize: 8
                                // },
                                {
                                  text: `${this.resultDoc.footerText}`,
                                  alignment: "center",
                                  fontSize: 8
                                },
                                {
                                  text: `${currentPage.toString()}`,
                                  alignment: "center",
                                  fontSize: 9
                                }
                              ],
                              layout: { defaultBorder: false },
                              border: [false, true, false, false]
                            },
                            { text: "", border: [true, false, false, false] }
                          ]
                        ]
                      }
                    }
                  ];
                },
                //end footer
                // userPassword: '123',
                // watermark: {
                //   text: "TAPLAW DRAFT",
                //   color: "red",
                //   opacity: 0.3,
                //   angle: 70,
                //   fontSize: 40,
                // },
                content: [
                  // AUTHOR STACK
                  {
                    stack: [
                      authorStack,

                      // { text: `${this.user.email}`, lineHeight: 0.6 },

                      {
                        text: `${this.firm.firmName.toUpperCase()}`,
                        lineHeight: 1.0
                      },
                      {
                        text: `${this.firm.firmAddressLine.toUpperCase()}`,
                        lineHeight: 1.0
                      },
                      {
                        text: `${this.firm.firmCityStateZip.toUpperCase()}`,
                        lineHeight: 1.0
                      },
                      {
                        text: `TELEPHONE: ${this.firm.firmPhone
                          .trim()
                          .toUpperCase()}`,
                        lineHeight: 1.0
                      },
                      {
                        text: `FACSIMILE: ${this.firm.firmPhone
                          .trim()
                          .toUpperCase()}`,
                        lineHeight: 1.0
                      },
                      // { text: `${this.user.email}`, lineHeight: 1.0 },
                      { text: " ", lineHeight: 1.0 },
                      {
                        text: `Attorneys for:  ${this.responses.partyName.toUpperCase() ||
                          "Plaintiffs"}`,
                        lineHeight: 1.0
                      }
                    ],
                    margin: [44, 2, 7, 0],
                    lineHeight: 0,
                    fontSize: 12
                  },
                  //JURISDICTION STACK
                  {
                    stack: [
                      {
                        text: `SUPERIOR COURT OF THE STATE OF CALIFORNIA`,
                        margin: [0, 40, 0, 0]
                      },
                      // {
                      //   text: `FOR THE COUNTY OF ${this.matter.jdxCounty.toUpperCase() ||
                      //     "null"}`
                      // }
                      {
                        text: `FOR THE COUNTY OF ${this.matter.jdxCounty ||
                          "null"}`
                      }
                    ],
                    fontSize: 12,
                    alignment: "center",
                    lineHeight: 1,
                    bold: true
                  },

                  //BEGIN CAPTION STACK
                  this.resultDoc.caption,

                  //BEGIN BODY STACK
                  {
                    stack: [
                      this.resultDoc.docBody,

                      {
                        stack: [this.resultDoc.verificationStack],
                        margin: [0, 0, 40, 0]
                      },
                      // verificationStack,
                      // PROOF OF SERVICE STACK
                      {
                        stack: [
                          {
                            text: `PROOF OF SERVICE`,
                            alignment: "center",
                            bold: true,
                            pageBreak: "before",
                            margin: [0, 0, 0, 0]
                          },
                          { text: " " },
                          {
                            text: `STATE OF CALIFORNIA             )`,
                            alignment: "left"
                          },
                          {
                            text: `                                                ) ss.`,
                            alignment: "left",
                            preserveLeadingSpaces: true
                          },
                          {
                            text: `COUNTY OF LOS ANGELES      )`,
                            alignment: "left"
                          },
                          {
                            text: ` `
                          },
                          {
                            text: ` I am employed in the County of Los Angeles, State of California.  I am over the age of 18 and not a party to the within action; my business address is TAPLAW HEAD QUERTERS, LOS ANGELES CALIFORNIA. On ____________________, I served the foregoing document described as ###TEST DOC##### has been served on the interested party(ies) in this action as follows:`,
                            alignment: "justify"
                          },
                          { text: ` ` },
                          {
                            stack: [
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byMail || ""}`
                                      },
                                      {
                                        text: `(BY MAIL) TAPLAW has deposited such envelope in the mail at TAPLAW HEADQUARTERS. The envelope was mailed with postage thereon fully prepaid. I am readily familiar with TAPLAW's practice of collection and processing of correspondence for mailing. It is deposited with the U.S. Postal Service on the same day in the ordinary course of business. I am aware that on motion of the party served, service is presumed invalid if postal cancellation date or postage meter date is more than 1 day after date of deposit for mailing in affidavit. (TO ALL NOTED ON SERVICE LIST)`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byPersonalService || ""}`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(BY PERSONAL SERVICE) TAPLAW caused such envelope to be delivered by hand to the addressee(s).`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byOvernightDelivery ||
                                          ""}`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(BY OVERNIGHT DELIVERY) TAPLAW caused such envelope to be delivered by overnight delivery in a box regularly maintained by an overnight delivery service with delivery fees paid or provided for in accordance with ordinary business practices. (TO ALL NOTED ON SERVICE LIST)`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byEmail || ""}`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(BY EMAIL) Based on court order or an agreement of the parties to accept service by e-mail or electronic transmission, TAPLAW caused such documents to be sent to the persons at the email addressses listed in the attahced mailing list. TAPLAW has not received any electronic message or other indication that the transmission was unsuccessfull.(TO ALL NOTED ON SERVICE LIST)`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `X`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(STATE) I declare under penalty of perjury under the laws of the State of California that the above is true and correct.`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `    `
                                      },
                                      {
                                        text: `(FEDERAL) I declare under penalty of perjury under the laws of the United States of America that the above is true and correct.`
                                        // margin: [60, 0, 0, 0]
                                      }
                                    ]
                                  ]
                                }
                              }
                            ]
                          }
                        ],
                        lineHeight: 1.0,
                        alignment: "justify",
                        margin: [0, 0, 40, 0]
                      }
                    ],
                    lineHeight: 1.8,
                    fontSize: 12,
                    margin: [44, 0, 0, 0]
                  } //END BODY
                ],
                pageMargins: [42, 78, 55, 40], //END CONENT SACK

                //BEGIN BACKGROUND STYLES
                styles: {
                  header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                  },
                  subheader: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 5]
                  },
                  tableExample: {
                    margin: [0, 0, 0, 0]
                  },
                  tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: "black"
                  }
                },
                defaultStyle: {
                  // alignment: 'justify',
                  font: "TimesRoman"
                },
                pageSize: "LETTER"
              }; //END (dd) DOCUMENT DENFENITION
              // let title = `${this.plaintiff.fullName}_${this.selectedDoc}`;
              this.doc = pdfMake.createPdf(docDef);
              // doc.download(title);
              this.doc.getDataUrl(url => {
                this.iframeSrc = url;
              });
              let invoiceNumber = Math.floor(Math.random() * 90000) + 100000;

              let docDefinitionInvoice = {
                defaultStyle: {
                  // alignment: 'justify',
                  font: "TimesRoman",
                  fontSize: 12
                },
                pageSize: "LETTER",

                pageMargins: [30, 30, 30, 30],
                // pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
                //   return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
                // },
                content: [
                  {
                    canvas: [
                      {
                        type: "line",
                        x1: 0,
                        y1: 5,
                        x2: 595 - 2 * 40,
                        y2: 5,
                        lineWidth: 3
                      }
                    ]
                  },

                  { text: `TAPLAW INVOICE`, fontSize: 20 },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  { text: "TAPLAW INC.", fontSize: 12 },
                  { text: "352 S Cloverdale Ave.", fontSize: 12 },
                  { text: "Los Angeles, CA 90036", fontSize: 12 },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  { text: `TO: ` },
                  { text: `${this.firm.firmName}` },
                  { text: `${this.firm.firmAddressLine}` },
                  { text: `${this.firm.firmCityStateZip}` },
                  { text: `${this.firm.firmPhone}` },

                  { text: " " },
                  { text: " " },
                  { text: " " },
                  {
                    text: "Please make checks payable to Taplaw Inc.",
                    fontSize: 12
                  },
                  { text: "Tax ID #: 87-4047075", fontSize: 12 },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  {
                    text: `RE: ${this.matter.internalID} - ${this.matter.caseName} - ${this.responses.partyName}`
                  },
                  {
                    text: `Invoice No.: ${invoiceNumber}`,
                    fontSize: 20
                  },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  { text: `DATE:  ${moment().format("LL")}` },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  { text: " " },
                  {
                    table: {
                      headerRows: 1,
                      dontBreakRows: true,
                      widths: ["*", "*"],
                      body: [
                        [
                          { text: `ITEM`, alignment: "center" },
                          { text: `AMOUNT DUE`, alignment: "center" }
                        ],
                        [
                          {
                            // text: `Contents List Pricing - \n ${itemCount} Items Priced ($0.75  per item)`,
                            text: `AUTOMATED ${
                              this.selectedDoc
                            } - ${this.responses.partyName.toUpperCase()} \n `,
                            alignment: "center"
                          },
                          { text: `$99.00`, alignment: "center" }
                        ]
                      ]
                    }
                  }
                ]
              };

              this.invoice = pdfMake.createPdf(docDefinitionInvoice);
              this.invoice.download(
                `${invoiceNumber}-${this.plaintiff.partySlug}-${this.matter.internalID}-${this.matter.matterSlug}.pdf`
              );
              this.overlay = false;
            })
            .catch(err => {
              console.log(err);
              this.overlay = false;
            });
        } else {
          ///
          ///
          ///
          ///this is for older clients intput,
          //they will be deleted and so will this section
          ///
          ///
          this.overlay = true;
          getDocDef({
            matter: this.matter,
            user: this.user,
            selectedDoc: this.selectedDoc,
            attorneySignature: this.attorneySignature,
            selectedAttorney: this.selectedAttorney,
            responses: this.responses,
            authorStack,
            // verificationStack,
            titleStack,
            signatureBody,
            plaintiffString: this.plaintiffString,
            defendantString: this.defendantString,
            firm: this.firm,
            docDate: moment().format("LL")
          })
            .then(result => {
              console.log("selected Doc", this.selectedDoc);
              this.resultDoc = result.data;
              console.log("doc def from cloud function", this.resultDoc);
              //place docdef in here
              let docDef = {
                // ...

                background: () => {
                  return [
                    {
                      style: "tableExample",
                      table: {
                        widths: [72, "*", 36],
                        body: [
                          [
                            {
                              text: "",
                              border: [false],
                              margin: [0, 72, 0, 0]
                            },
                            {
                              text: "",
                              border: [true, false, true, false]
                            },
                            {
                              text: "",
                              border: [false]
                            }
                          ],
                          [
                            {
                              stack: [
                                { text: "1" },
                                { text: "2" },
                                { text: "3" },
                                { text: "4" },
                                { text: "5" },
                                { text: "6" },
                                { text: "7" },
                                { text: "8" },
                                { text: "9" },
                                { text: "10" },
                                { text: "11" },
                                { text: "12" },
                                { text: "13" },
                                { text: "14" },
                                { text: "15" },
                                { text: "16" },
                                { text: "17" },
                                { text: "18" },
                                { text: "19" },
                                { text: "20" },
                                { text: "21" },
                                { text: "22" },
                                { text: "23" },
                                { text: "24" },
                                { text: "25" },
                                { text: "26" },
                                { text: "27" },
                                { text: "28" }
                              ],
                              alignment: "right",
                              lineHeight: 1.8,
                              border: [false, false, true, false],
                              margin: []
                            }, //END BACKGROUND STACK OBJECT
                            [
                              {
                                text: ""
                              }
                            ],
                            {
                              text: [" "],
                              border: [true, false, false, false]
                            }
                          ]
                        ] //END BACKGROUND BODY ARRAY
                      },
                      layout: { defaultBorder: false } //END BACKGROUND TABLE OBJECT
                    } //END BACKGROUND OBJECT
                  ]; //END BACKGROUND RETURN ARRAY
                }, //END BACKGROUND

                //BEGIN FOOTER
                // footer: function(currentPage, pageCount){
                footer: currentPage => {
                  return [
                    {
                      table: {
                        widths: [72, "*", 36],
                        // heights: [72,72,72],
                        body: [
                          [
                            {
                              text: "",
                              border: [false, false, true, false]
                            },
                            {
                              stack: [
                                //TESTING TO SELECT PLAINTIFF
                                // {text: `${matter.plaintiffs[0].fullName.toUpperCase()}'S --document title --`, alignment: 'center', fontSize: 12},
                                // {text: `${finalDocument.questions[0].response}`, alignment: 'center', fontSize: 8},
                                // {
                                //   text: `${this.plaintiff.fullName}`,
                                //   alignment: "center",
                                //   fontSize: 8
                                // },
                                {
                                  text: `${this.resultDoc.footerText}`,
                                  alignment: "center",
                                  fontSize: 8
                                },
                                {
                                  text: `${currentPage.toString()}`,
                                  alignment: "center",
                                  fontSize: 9
                                }
                              ],
                              layout: { defaultBorder: false },
                              border: [false, true, false, false]
                            },
                            { text: "", border: [true, false, false, false] }
                          ]
                        ]
                      }
                    }
                  ];
                },
                //end footer
                // userPassword: '123',
                // watermark: {
                //   text: "TAPLAW DRAFT",
                //   color: "red",
                //   opacity: 0.3,
                //   angle: 70,
                //   fontSize: 40,
                // },
                content: [
                  // AUTHOR STACK
                  {
                    stack: [
                      authorStack,

                      // { text: `${this.user.email}`, lineHeight: 0.6 },

                      {
                        text: `${this.firm.firmName.toUpperCase()}`,
                        // lineHeight: 0.6
                        lineHeight: 1.5
                      },
                      {
                        text: `${this.firm.firmAddressLine.toUpperCase()}`,
                        // lineHeight: 0.6
                        lineHeight: 1.5
                      },
                      {
                        text: `${this.firm.firmCityStateZip.toUpperCase()}`,
                        // lineHeight: 0.6
                        lineHeight: 1.5
                      },
                      {
                        text: `TELEPHONE: ${this.firm.firmPhone
                          .trim()
                          .toUpperCase()}`,
                        // lineHeight: 0.6
                        lineHeight: 1.5
                      },
                      {
                        text: `FACSIMILE: ${this.firm.firmPhone
                          .trim()
                          .toUpperCase()}`,
                        // lineHeight: 0.6
                        lineHeight: 1.5
                      },
                      // { text: `${this.user.email}`, lineHeight: 1.5 },
                      { text: " ", lineHeight: 1.5 },
                      {
                        text: `Attorneys for:  ${this.responses.fullName.toUpperCase() ||
                          "Plaintiffs"}`,
                        // lineHeight: 0.7
                        lineHeight: 2
                      }
                    ],
                    margin: [44, 2, 7, 0],
                    lineHeight: 0,
                    fontSize: 12
                  },
                  //JURISDICTION STACK
                  {
                    stack: [
                      {
                        text: `SUPERIOR COURT OF THE STATE OF CALIFORNIA`,
                        margin: [0, 40, 0, 0]
                      },
                      // {
                      //   text: `FOR THE COUNTY OF ${this.matter.jdxCounty.toUpperCase() ||
                      //     "null"}`
                      // }
                      {
                        text: `FOR THE COUNTY OF ${this.matter.jdxCounty ||
                          "null"}`
                      }
                    ],
                    fontSize: 12,
                    alignment: "center",
                    lineHeight: 1,
                    bold: true
                  },

                  //BEGIN CAPTION STACK
                  this.resultDoc.caption,

                  //BEGIN BODY STACK
                  {
                    stack: [
                      this.resultDoc.docBody,

                      {
                        stack: [this.resultDoc.verificationStack],
                        margin: [0, 0, 40, 0]
                      },
                      // verificationStack,
                      // PROOF OF SERVICE STACK
                      {
                        stack: [
                          {
                            text: `PROOF OF SERVICE`,
                            alignment: "center",
                            bold: true,
                            pageBreak: "before",
                            margin: [0, 0, 0, 0]
                          },
                          { text: " " },
                          {
                            text: `STATE OF CALIFORNIA             )`,
                            alignment: "left"
                          },
                          {
                            text: `                                                ) ss.`,
                            alignment: "left",
                            preserveLeadingSpaces: true
                          },
                          {
                            text: `COUNTY OF LOS ANGELES      )`,
                            alignment: "left"
                          },
                          {
                            text: ` `
                          },
                          {
                            text: ` I am employed in the County of Los Angeles, State of California.  I am over the age of 18 and not a party to the within action; my business address is TAPLAW HEAD QUERTERS, LOS ANGELES CALIFORNIA. On ____________________, I served the foregoing document described as ###TEST DOC##### has been served on the interested party(ies) in this action as follows:`,
                            alignment: "justify"
                          },
                          { text: ` ` },
                          {
                            stack: [
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byMail || ""}`
                                      },
                                      {
                                        text: `(BY MAIL) TAPLAW has deposited such envelope in the mail at TAPLAW HEADQUARTERS. The envelope was mailed with postage thereon fully prepaid. I am readily familiar with TAPLAW's practice of collection and processing of correspondence for mailing. It is deposited with the U.S. Postal Service on the same day in the ordinary course of business. I am aware that on motion of the party served, service is presumed invalid if postal cancellation date or postage meter date is more than 1 day after date of deposit for mailing in affidavit. (TO ALL NOTED ON SERVICE LIST)`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byPersonalService || ""}`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(BY PERSONAL SERVICE) TAPLAW caused such envelope to be delivered by hand to the addressee(s).`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byOvernightDelivery ||
                                          ""}`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(BY OVERNIGHT DELIVERY) TAPLAW caused such envelope to be delivered by overnight delivery in a box regularly maintained by an overnight delivery service with delivery fees paid or provided for in accordance with ordinary business practices. (TO ALL NOTED ON SERVICE LIST)`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `${this.byEmail || ""}`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(BY EMAIL) Based on court order or an agreement of the parties to accept service by e-mail or electronic transmission, TAPLAW caused such documents to be sent to the persons at the email addressses listed in the attahced mailing list. TAPLAW has not received any electronic message or other indication that the transmission was unsuccessfull.(TO ALL NOTED ON SERVICE LIST)`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `X`,
                                        border: [true, true, true, false]
                                      },
                                      {
                                        text: `(STATE) I declare under penalty of perjury under the laws of the State of California that the above is true and correct.`,
                                        // margin: [60, 0, 0, 0]
                                        border: [true, true, true, false]
                                      }
                                    ]
                                  ]
                                }
                              },
                              {
                                table: {
                                  widths: [10, "*"],
                                  body: [
                                    [
                                      {
                                        text: `    `
                                      },
                                      {
                                        text: `(FEDERAL) I declare under penalty of perjury under the laws of the United States of America that the above is true and correct.`
                                        // margin: [60, 0, 0, 0]
                                      }
                                    ]
                                  ]
                                }
                              }
                            ]
                          }
                        ],
                        lineHeight: 1.0,
                        alignment: "justify",
                        margin: [0, 0, 40, 0]
                      }
                    ],
                    // lineHeight: 1.15,
                    lineHeight: 1.8,
                    fontSize: 12,
                    margin: [44, 0, 0, 0]
                  } //END BODY
                ],

                pageMargins: [42, 78, 55, 40], //END CONENT SACK

                //BEGIN BACKGROUND STYLES
                styles: {
                  header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                  },
                  subheader: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 5]
                  },
                  tableExample: {
                    margin: [0, 0, 0, 0]
                  },
                  tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: "black"
                  }
                },
                defaultStyle: {
                  // alignment: 'justify',
                  font: "TimesRoman"
                },
                pageSize: "LETTER"
              }; //END (dd) DOCUMENT DENFENITION

              this.doc = pdfMake.createPdf(docDef).download();
              // console.log("doc after .createPdf() function with docDef", this.doc);
              this.doc.getDataUrl(url => {
                this.iframeSrc = url;
              });
              this.overlay = false;
            })
            .catch(err => {
              console.log(err);
              this.overlay = false;
            });
        }
      }
    }
  },
  created() {
    console.log("hello from created at plaintff doc dialog");
    console.log("firm", this.firm);
    console.log("user", this.user);
    if (this.user) {
      this.$store.dispatch("getFirm", this.user.firmSlug);
    }
    console.log("matter", this.matter);
    console.log("responses", this.responses);
    console.log("plaintiff", this.plaintiff);
  }
};
</script>
<style lang="scss" scoped></style>
